module.exports = __webpack_public_path__ + "img/人间失格.cce45656.png";